exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-47be4e25]{width:400%}.title[data-v-47be4e25]{font-size:24px;font-weight:700;padding:20px;border-bottom:thin solid #ccc}.box-request[data-v-47be4e25]{width:100%;height:auto;padding:20px;font-size:15px;text-align:left}.highlight[data-v-47be4e25]{color:red;font-weight:700}.shortfontwidth[data-v-47be4e25]{word-spacing:-3pt}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47be4e25","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/Search.vue
// module id = E2c1
// module chunks = 3